import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestContent from './components/LatestContent';
import FAQSection from './components/FAQSection';

const homeSEO = {
  title: '蘑菇视频官网 - 官方正版视频平台入口 | 免费观看海量高清视频',
  description: '蘑菇视频官网是您访问蘑菇视频的官方正版入口，提供最新影视、综艺、短视频内容。在蘑菇视频官网免费观看海量高清视频，支持多端同步，安全稳定，立即访问蘑菇视频官网，畅享极致视频体验。',
  keywords: '蘑菇视频官网,蘑菇视频官方网站,蘑菇视频免费观看,蘑菇视频下载,蘑菇视频app官网,蘑菇视频高清播放,蘑菇视频最新入口',
  canonicalUrl: '/',
};

export default function Home() {
  return (
    <>
      <SEOHead {...homeSEO} />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotRecommend />
        <LatestContent />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}